// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"4dc7a65c","400":"557019ad","453":"236d8090","667":"4afaea2c"}[chunkId] + ".chunk.js";
};